import ReportWithoutCriteria from '../ReportWithoutCriteria';
import {
  BOOKS_MISSING_ANSWERS_REPORT_ERROR,
  BOOKS_MISSING_ANSWERS_REPORT_LOADING,
  BOOKS_MISSING_ANSWERS_REPORT_SUCCESS,
} from './reportStates';

export default function BooksMissingAnswersReport({
  generateBooksMissingAnswersReport,
  getLatestBooksMissingAnswersReport,
  booksMissingAnswersReportData,
  booksMissingAnswersReportState,
}) {
  return (
    <ReportWithoutCriteria
      name="Books Missing Answers Report"
      link={booksMissingAnswersReportData.link}
      currentState={booksMissingAnswersReportState}
      stateLoading={BOOKS_MISSING_ANSWERS_REPORT_LOADING}
      stateError={BOOKS_MISSING_ANSWERS_REPORT_ERROR}
      stateSuccess={BOOKS_MISSING_ANSWERS_REPORT_SUCCESS}
      getLatestFunc={getLatestBooksMissingAnswersReport}
      generateFunc={generateBooksMissingAnswersReport}
    />
  );
}
